import type { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    row: {
        padding: ".75rem 0",
        borderTop: `1px solid ${theme.palette.tailwind.slate[100]}`,
    },
    rowWithoutBorder: {
        borderTop: "none",
    },
    label: {
        minWidth: "6.5rem",
        color: theme.palette.tailwind.slate[500],
    },
    value: {
        fontWeight: 600,
        textAlign: "right",
        overflowWrap: "anywhere",
        color: theme.palette.tailwind.slate[900],
    },
}))

type Props = Readonly<{
    label: ReactNode
    value: ReactNode
    hasBorder?: boolean
}>

export function MeetingRoomDetailRow({ label, value, hasBorder = true }: Props) {
    const { classes, cx } = useStyles()

    return (
        <Stack
            direction="row"
            alignItems="baseline"
            justifyContent="space-between"
            spacing="1.125rem"
            className={cx(classes.row, !hasBorder && classes.rowWithoutBorder)}
        >
            <Typography variant="body2" className={classes.label}>
                {label}
            </Typography>
            <Typography variant="subtitle1" className={classes.value}>
                {value}
            </Typography>
        </Stack>
    )
}
